export const CAMPAIGN_PARAMS_COOKIE_NAME = 'jabra_campaign_params';

const getCampaignParamsCookieValue = (): string | null => {
  if (typeof document === 'undefined') return null;

  const cookiePrefix = `${CAMPAIGN_PARAMS_COOKIE_NAME}=`;
  const cookie = document.cookie
    .split(';')
    .map((part) => part.trim())
    .find((part) => part.startsWith(cookiePrefix));

  return cookie ? decodeURIComponent(cookie.slice(cookiePrefix.length)) : null;
};

const getUrlSearchString = (): string | null => {
  if (typeof window === 'undefined') return null;

  return window === window.parent ? window.location.search : window.parent.location.search;
};

// Prefers the value from the current URL, falling back to the persisted campaign params cookie.
export const getCampaignParamValue = (key: string): string | null => {
  const searchString = getUrlSearchString();
  const valueFromUrl = searchString ? new URLSearchParams(searchString).get(key) : null;

  if (valueFromUrl) {
    return valueFromUrl;
  }

  const campaignParamsValue = getCampaignParamsCookieValue();

  if (!campaignParamsValue) {
    return null;
  }

  return new URLSearchParams(campaignParamsValue).get(key);
};

export const appendCampaignParamsToUrl = (url: string): string => {
  const campaignParamsValue = getCampaignParamsCookieValue();

  if (!campaignParamsValue) {
    return url;
  }

  try {
    const targetUrl = new URL(url);
    const campaignParams = new URLSearchParams(campaignParamsValue);

    campaignParams.forEach((value, key) => {
      targetUrl.searchParams.set(key, value);
    });

    return targetUrl.toString();
  } catch {
    return url;
  }
};

export const clearCampaignParamsCookie = (): void => {
  if (typeof document === 'undefined') return;

  document.cookie = [
    `${CAMPAIGN_PARAMS_COOKIE_NAME}=`,
    'expires=Thu, 01 Jan 1970 00:00:00 GMT',
    'max-age=0',
    'path=/',
  ].join('; ');
};
